
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { useState } from 'react';
import {
  Drawer,
  Layout,
  Button,
  Category,
  Position,
} from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';
export const DrawerController = ({
  component: Component
}) => {
  const [visible, setVisibility] = useState(false);
  return <div style={{
    border: '2px solid red',
    background: 'lightgrey'
  }}>
      <Layout bar={React.cloneElement(Component, {
      visible,
      onClickClose: () => setVisibility(false)
    })} position={Position.RIGHT} mdxType="Layout">
        <div style={{
        height: 500,
        padding: 20
      }}>
          <Button onClick={() => setVisibility(true)} mdxType="Button">Show drawer</Button>
          <div style={{
          width: '100%',
          height: 200,
          background: 'orange',
          marginTop: 20,
          padding: 20
        }}>
            Im the body content
          </div>
        </div>
      </Layout>
    </div>;
};

const layoutProps = {
  DrawerController
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Drawer`}</h1>
<p>{`Similarly to how a Modal works, the Drawer component is stateless, meaning you should control its visibility. It serves a similar purpose to the modal, but the content is served from the right side of the page, and can either overlay the whole page (like a modal) or be inline with the content.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Drawer } from '@drawbotics/react-drylus';
`}</code></pre>
<p>{`All the rendered drawers are automatically attached to the end of the DOM through a `}<inlineCode parentName="p">{`drawers-outlet`}</inlineCode>{`.`}</p>

<p>{`Usage:`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const Example = () => {
  const [ drawerVisible, setDrawerVisibility ] = useState(false);

  return (
    <div>
      <Button onClick={() => setDrawerVisibility(true)}>Click to show drawer</Button>
      <Drawer
        visible={drawerVisible}
        onClickClose={() => setDrawerVisibility(false)}>
        <div>
          Im some content
        </div>
      </Drawer>
    </div>
  );
};
`}</code></pre>
<p>{`Interactive example:`}</p>
<Playground __position={0} __code={`<DrawerController component={
  <Drawer visible={false}>
    <div style={{ height: 1000, background: 'linear-gradient(red, blue)' }}>
      Im some content
    </div>
  </Drawer>
} />`} component={Drawer} mdxType="Playground">
  <DrawerController component={<Drawer visible={false} mdxType="Drawer">
      <div style={{
          height: 1000,
          background: 'linear-gradient(red, blue)'
        }}>
        Im some content
      </div>
    </Drawer>} mdxType="DrawerController" />
</Playground>
<p>{`You may also have a footer and a title:`}</p>
<Playground __position={1} __code={`<DrawerController component={
  <Drawer visible={false} title="Title of drawer" footer={<Button category={Category.BRAND} fullWidth>Footer action</Button>}>
    <div style={{ height: 1000, background: 'linear-gradient(red, blue)' }}>
      Im some content
    </div>
  </Drawer>
} />`} mdxType="Playground">
  <DrawerController component={<Drawer visible={false} title="Title of drawer" footer={<Button category={Category.BRAND} fullWidth mdxType="Button">Footer action</Button>} mdxType="Drawer">
      <div style={{
          height: 1000,
          background: 'linear-gradient(red, blue)'
        }}>
        Im some content
      </div>
    </Drawer>} mdxType="DrawerController" />
</Playground>
<p>{`The `}<inlineCode parentName="p">{`raw`}</inlineCode>{` property can be useful if you want to have some custom content in your drawer that does not follow the "classic" style. E.g.`}</p>
<Playground __position={2} __code={`<DrawerController component={
  <Drawer asOverlay raw visible={false}>
    <div style={{ height: '100%', width: '100%' }}>
      <img src="https://i.ytimg.com/vi/qfS84lQbkw8/maxresdefault.jpg" style={{ objectFit: 'cover', height: '100%', width: '100%' }} />
    </div>
  </Drawer>
} />`} mdxType="Playground">
  <DrawerController component={<Drawer asOverlay raw visible={false} mdxType="Drawer">
      <div style={{
          height: '100%',
          width: '100%'
        }}>
        <img src="https://i.ytimg.com/vi/qfS84lQbkw8/maxresdefault.jpg" style={{
            objectFit: 'cover',
            height: '100%',
            width: '100%'
          }} />
      </div>
    </Drawer>} mdxType="DrawerController" />
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;